/* =============================================================
   ROOTED IN REFUGE — Cart Drawer Bridge
   1. Opens Minimog's drawer after any successful cart/add request,
      regardless of who initiated it (Gem Pages, Kaching, native, etc.)
   2. Defensively hides non-Note addon buttons (Shipping, Coupon)
      until precise CSS selectors are confirmed.
   ============================================================= */

(function () {
  'use strict';

  // ─── 1. DRAWER OPENER ────────────────────────────────────────

  function openMinimogDrawer() {
    const drawer = document.querySelector('m-cart-drawer#MinimogCartDrawer')
                || document.querySelector('m-cart-drawer');
    if (!drawer) return;

    // Refresh contents from server (re-renders items, discounts, subtotal, savings)
    if (typeof drawer.onCartDrawerUpdate === 'function') {
      drawer.onCartDrawerUpdate();
    }

    // Open the drawer after a brief delay to let DOM settle
    setTimeout(() => {
      if (typeof drawer.open === 'function') {
        drawer.open();
      }
    }, 200);
  }

  function isAddToCartUrl(url) {
    if (!url || typeof url !== 'string') return false;
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  // Intercept fetch (modern AJAX add-to-cart flows)
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const input = args[0];
    const url = typeof input === 'string' ? input : (input && input.url);
    const promise = originalFetch.apply(this, args);

    if (isAddToCartUrl(url)) {
      promise.then(response => {
        if (response && response.ok) {
          openMinimogDrawer();
        }
      }).catch(() => { /* swallow */ });
    }
    return promise;
  };

  // Intercept XHR (older / jQuery-based add-to-cart flows)
  const originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__rootedUrl = url;
    return originalXHROpen.apply(this, arguments);
  };

  const originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (isAddToCartUrl(this.__rootedUrl)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          openMinimogDrawer();
        }
      });
    }
    return originalXHRSend.apply(this, arguments);
  };

  // Listen for common cross-app cart events as a final fallback
  ['cart:added', 'cart:updated', 'cart:refresh', 'shopify:cart:add'].forEach(eventName => {
    document.addEventListener(eventName, () => openMinimogDrawer());
  });


  // ─── 2. ADDON BUTTON HIDER (keep only Note) ───────────────────

  function hideNonNoteAddons() {
    const drawer = document.querySelector('m-cart-drawer');
    if (!drawer) return;

    // Common Minimog addon button selectors
    const candidateSelectors = [
      '.m-cart-addon__trigger',
      '.m-cart__addon-trigger',
      '.m-cart-addon--trigger',
      '[data-cart-addon]',
      '[data-addon-trigger]',
      '[data-target*="addon"]'
    ];

    const buttons = drawer.querySelectorAll(candidateSelectors.join(','));
    buttons.forEach(btn => {
      const text = (btn.textContent || '').toLowerCase().trim();
      const data = (btn.dataset.cartAddon || btn.dataset.target || '').toLowerCase();

      const isNote =
        text.includes('note') ||
        data.includes('note') ||
        btn.querySelector('[class*="note"]');

      if (!isNote) {
        btn.style.display = 'none';
      }
    });
  }

  // Run on first load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideNonNoteAddons);
  } else {
    hideNonNoteAddons();
  }

  // Re-run when the drawer re-renders (Minimog re-renders sections after cart updates)
  const drawerEl = document.querySelector('m-cart-drawer');
  if (drawerEl) {
    new MutationObserver(() => {
      // Throttle to avoid loops
      if (drawerEl.__rootedAddonsThrottle) return;
      drawerEl.__rootedAddonsThrottle = true;
      requestAnimationFrame(() => {
        hideNonNoteAddons();
        drawerEl.__rootedAddonsThrottle = false;
      });
    }).observe(drawerEl, { childList: true, subtree: true });
  }

})();